function loadFooterButterflyCert() {
    if (window.plPassportHelper) {
        plPassportHelper.init({
          brandId: '51dd604a-e1cd-4091-9542-745ac2af98f1',
          mode: 'widget',
          type: 'simple-badge',
          floating: false,
          colorScheme: 'black',
          align: 'left',
        })
    }
}

document.addEventListener('DOMContentLoaded', loadFooterButterflyCert);